import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
  },
  section: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    /** Space between {@link SectionHeader} (`<header>`) and the fields below (16px). */
    gap: theme.spacing(2),
  },
  gridContainer: {
    width: '100%',
  },
  textFieldContainer: {
    width: '100%',
  },
  socialsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
  },
}));
